export const gbpToPence = (value: string) => {
  const pounds = Number.parseFloat(value);
  if (Number.isNaN(pounds)) {
    return null;
  }
  return Math.trunc(pounds * 100);
};
